import { Button } from '@mui/material'

type TripBuilderRowActionProps = {
  label: string
  onClick: () => void
  color?: 'primary' | 'error'
}

const TripBuilderRowAction = ({
  label,
  onClick,
  color = 'primary',
}: TripBuilderRowActionProps) => (
  <Button
    variant="contained"
    color={color}
    onClick={onClick}
    sx={{
      textTransform: 'none',
      fontWeight: 600,
      whiteSpace: 'nowrap',
      px: 1.5,
      py: 0.5,
      minWidth: 'auto',
      borderRadius: '6px',
      boxShadow: 'none',
      fontSize: '0.8125rem',
      '&:hover': { boxShadow: 'none' },
    }}
  >
    {label}
  </Button>
)

export default TripBuilderRowAction
